import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component, Children, cloneElement } from 'react';
import Badge from '../Badge';
import HelperDrawer from '../HelperDrawer';
import StackView from '../StackView';
import { generateId } from '../utils';
import ToolbarAction from './Action';

var Toolbar = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Toolbar, _Component);

  function Toolbar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "helperDrawerId", generateId('toolbar-helper-drawer'));

    return _this;
  }

  var _proto = Toolbar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        actions = _this$props.actions,
        count = _this$props.count,
        countColor = _this$props.countColor,
        helpContent = _this$props.helpContent,
        onStatusClearRequest = _this$props.onStatusClearRequest,
        status = _this$props.status,
        title = _this$props.title,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["actions", "count", "countColor", "helpContent", "onStatusClearRequest", "status", "title"]);

    return /*#__PURE__*/React.createElement(StackView, restProps, /*#__PURE__*/React.createElement(StackView, {
      alignment: "center",
      axis: "horizontal",
      distribution: "space-between",
      spacing: 1
    }, /*#__PURE__*/React.createElement(StackView, {
      alignment: "center",
      axis: "horizontal",
      grow: 1,
      shrink: 1
    }, title, count && /*#__PURE__*/React.createElement(Badge, {
      color: countColor,
      marginLeft: 0.75,
      radius: "circle",
      size: "xs",
      title: count
    }), helpContent && /*#__PURE__*/React.createElement(HelperDrawer.Toggle, {
      drawerId: this.helperDrawerId,
      marginLeft: 0.25,
      tooltip: {
        title: 'More info',
        triggerOnFocus: false
      }
    })), (status || actions) && /*#__PURE__*/React.createElement(StackView, {
      axis: "horizontal",
      spacing: status && actions ? 1 : 0
    }, status && /*#__PURE__*/React.createElement(Badge.Status, {
      onClearRequest: onStatusClearRequest,
      size: "xs",
      status: status,
      title: status === 'success' ? 'Saved' : 'Error'
    }), actions && /*#__PURE__*/React.createElement(StackView, {
      axis: "horizontal",
      spacing: actions.length > 1 ? 1 : 0
    }, Children.map(actions, function (child) {
      return child && child.type.displayName === 'ToolbarAction' ? child : /*#__PURE__*/cloneElement(child, {
        size: child.props.size || 'xs',
        theme: child.props.theme || 'primary',
        variant: child.props.variant || 'outline'
      });
    })))), helpContent && /*#__PURE__*/React.createElement(HelperDrawer, {
      children: helpContent,
      id: this.helperDrawerId,
      marginTop: 1
    }));
  };

  return Toolbar;
}(Component);

_defineProperty(Toolbar, "Action", ToolbarAction);

_defineProperty(Toolbar, "defaultProps", {
  countColor: 'grey-7'
});

export default Toolbar;